const ComponentSelectionEndpoint = {
  GET_COMPONENT_SELECTION: '/default/component-selection/get-selected-components',
  SET_COMPONENT_SELECTION: '/default/component-selection/set-selected-components',
};

export default ComponentSelectionEndpoint;
